module.exports = __webpack_public_path__ + "static/media/stadium_story03.847f831a.mp4";